import { useEffect, useMemo, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select } from '@mantine/core';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { useDebouncedCallback } from '@mantine/hooks';
import { usePaginatedQuery } from '../../../http/queries/usePaginatedQuery';

const SearchableSelect = ({
    queryHttpFn,
    queryKey,
    optionsMapFn,
    defaultValue,
    filters,
    pageSize = 200,
    onChange,
    renderOption,
    cacheKeyFn = (x) => x.id,
    ...props
}) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize,
    });
    const [currentOption, setCurrentOption] = useState(defaultValue);
    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) => queryHttpFn(queryParams),
        queryKey: Array.isArray(queryKey) ? queryKey : [queryKey],
        refetchInterval: 15_0000,
        globalFilter,
        filters,
        pagination,
        sorting: [],
    });

    useEffect(() => {
        setCurrentOption(defaultValue);
    }, [defaultValue]);

    const { data: queryData, pagination: queryPagination } =
        paginatedData || {};

    const selectOptions = useMemo(() => {
        if (!queryData) {
            return [];
        }

        if (!optionsMapFn) {
            console.warn('no optionsMapFn');
            return [];
        }
        const ret = queryData.map(optionsMapFn);
        if (currentOption && !ret.some((x) => x.value == currentOption.value)) {
            return [currentOption, ...ret];
        }
        return ret;
    }, [queryData, defaultValue]);

    const handleChange = (value) => {
        const selectedOption = selectOptions.find((x) => x.value === value);
        if (selectedOption) {
            setCurrentOption(selectedOption);
        }
        onChange(value);
    };

    const internalRenderMultiSelectOption = ({ option, ...rest }) => {
        let obj = queryData.find((x) => cacheKeyFn(x) == option.value);
        if (!obj) {
            obj = selectedQueryData.find((x) => cacheKeyFn(x) == option.value);
        }
        return renderOption({
            option: option,
            queryData: obj,
            ...rest,
        });
    };

    return (
        <Select
            searchable={true}
            data={selectOptions}
            onChange={handleChange}
            defaultValue={defaultValue}
            filter={({ options, search }) => {
                if (true) {
                    filterDebounce(search);
                }
                return options;
            }}
            rightSection={
                isLoading ? (
                    <FontAwesomeIcon
                        icon={faSpinnerThird}
                        spin
                    />
                ) : null
            }
            renderOption={renderOption ? internalRenderMultiSelectOption : null}
            {...props}
        />
    );
};
export default SearchableSelect;
